module.exports = __webpack_public_path__ + "media/icons/positive_status-140a6758.png";